// =============================================================================
// ApiClientProvider — React context provider for ApiClient
// =============================================================================

import type { ReactNode } from 'react';
import type { ApiClient } from './client';
import { ApiClientContext } from './hooks';

interface ApiClientProviderProps {
  client: ApiClient;
  children: ReactNode;
}

/**
 * Provides the ApiClient instance to all descendant components.
 *
 * @example
 * ```tsx
 * import { createApiClient, ApiClientProvider } from '@tkpod/api-client';
 *
 * const apiClient = createApiClient({
 *   baseUrl: import.meta.env.VITE_API_URL,
 * });
 *
 * function App() {
 *   return (
 *     <ApiClientProvider client={apiClient}>
 *       <Router />
 *     </ApiClientProvider>
 *   );
 * }
 * ```
 */
export function ApiClientProvider({ client, children }: ApiClientProviderProps) {
  return (
    <ApiClientContext.Provider value={client}>{children}</ApiClientContext.Provider>
  );
}
